(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/graph/graph-points.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/graph/graph-points.js'); 
'use strict';

svs.sport.result_boxes.graph.GraphPoints = Backbone.Model.extend({
  defaults: function() {
    return {
      autoMinMax: true, 
      showEndWedge: true, 
      numberOfMatches: 13, 
      minMax: { min: 1, max: 13 }, 
      points: [] 
    };
  }
});

 })(window);